export default __webpack_public_path__ + "static/media/diamond_fire.d5691a30.png";